import { IsEmail, IsNotEmpty, IsPhoneNumber, IsString } from 'class-validator';
import i18n from 'src/i18n';

export class ContactFormInfo {
    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    name: string;

    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    work: string;

    @IsString()
    @IsEmail({}, { message: () => i18n.t('validation.invalidEmail') })
    email: string;

    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    @IsPhoneNumber('NO', {
        message: () => i18n.t('validation.invalidPhone'),
    })
    phoneNumber: string;

    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    subject: string;

    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    message: string;
}
